import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { AppMaterialModule } from '../../app-material/app-material.module';
import { FlexLayoutModule } from '@angular/flex-layout';

import { HeaderModule } from '../../core-components/header/header.module';
import { FooterModule } from '../../core-components/footer/footer.module';
import { InputErrorPipeModule } from '../../pipes/input-error-pipe.module';
import { AppBreadcrumbModule } from '@coreui/angular';
import { LanguageModule } from '../../core-components/language/language.module';

import { UserManagementComponent } from './user-management.component';
import { UserManagementRoutingModule } from './user-management-routing.module';
import { RegisterModule } from './register/register.module';
import { BreadcrumbModule } from 'xng-breadcrumb';
import { SharedComponentsModule } from '../../shared-components.module';
import { ToolbarModule } from '../../core-components/toolbar copy/toolbar.module';
import { EditUserComponent } from './edit-user/edit-user.component';


export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AppMaterialModule,
    AppBreadcrumbModule,
    HttpClientModule,
    TranslateModule,
    LanguageModule,
    FlexLayoutModule,
    UserManagementRoutingModule,
    HeaderModule,
    FooterModule,
    InputErrorPipeModule,
    RegisterModule,
    BreadcrumbModule,
    SharedComponentsModule,
    ToolbarModule
  ],
  declarations: [UserManagementComponent, EditUserComponent],
  entryComponents: [ EditUserComponent ]
})
export class UserManagementModule { }
